<template>
  <button
    class="button-component"
    :class="shadowClass"
    :style="buttonStyles"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    @click="$emit('click')"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script>
export default {
  name: "ButtonComponent",

  props: {
    text: {
      type: String,
      default: "Agenda una llamada",
    },
    backgroundColor: {
      type: String,
      default: "#F5F4F4",
    },
    textColor: {
      type: String,
      default: "#46254F",
    },
    shadowType: {
      type: String,
      default: "light",
      validator: (value) => ["light", "dark"].includes(value),
    },
  },

  data() {
    return {
      isHovered: false,
    };
  },

  computed: {
    buttonStyles() {
      return {
        backgroundColor: this.backgroundColor,
        color: this.textColor,
      };
    },

    shadowClass() {
      return `shadow-${this.shadowType}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/generalStyle/controls/genericButton";
</style>